<div [ngClass]="{ 'stick-to-header': ad.stickToTop }">
  <div class="justify-content-center"
    [ngClass]="ad.style | floCssClassSanitize">
    <flo-lazy
      [componentConstructor]="AdLoadingComponent"
      [initialProps]="config"
    ></flo-lazy>
  </div>
</div>
